import { Button, CircularProgress, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import Modal, { CommonModalProps } from "..";
import AssetSinglePreviewDocs from "../../../Pages/admin/Inventory/InventoryAssetSingle/AssetSinglePreview/asset-single-preview-docs";
import { DownloadFileFromUrl } from "../../../Utils/helpers";
import useJobActions from "../../../Utils/Hooks/useJobActions";
import { useTranslation } from "react-i18next";

export type ModalDocumentPreviewElementProps = {
  objectId: number;
};

export type ModalPreviewBatonPdfProps = CommonModalProps<ModalDocumentPreviewElementProps>;

const ModalPreviewBatonPdf = React.forwardRef<any, ModalPreviewBatonPdfProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, ...modalProps } = props;
  const { objectId } = modalProps;
  const [fileName, setFileName] = useState(`Baton QC Report`);

  const jobActions = useJobActions();
  const [isLoading, setIsLoading] = useState(true);
  const [url, setUrl] = useState<string>("");

  const handleDownloadClick = () => {
    DownloadFileFromUrl(url!, fileName);
  };

  const handleCancelClick = () => {
    closeModal();
  };

  useEffect(() => {
    jobActions.DownloadBatonQcPdf(objectId).then((response) => {
      setUrl(response.data);
      setFileName(response.fileName);
      setIsLoading(false);
    });
  }, [objectId]);

  return (
    <Modal
      title={fileName}
      reference={ref}
      closeModal={handleCancelClick}
      width={900}
      height={800}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button disabled={!url} color="success" variant="outlined" onClick={handleDownloadClick}>
            {t("common:download")}
          </Button>
        </Stack>
      }
    >
      {isLoading && (
        <CircularProgress
          sx={{
            position: "absolute",
            left: "47%",
            top: "47%",
          }}
          size={25}
        />
      )}
      {!isLoading && <AssetSinglePreviewDocs url={url} blob={true} blobExt=".pdf" />}
    </Modal>
  );
});

export default ModalPreviewBatonPdf;
